import {SET_SOUND_ON_OFF} from "@actions/actionTypes"

export default function soundReducer(state = false, action) {
    switch (action.type) {
        case SET_SOUND_ON_OFF:
            return action.payload
        default:
            return state;
    }
}